function handleSwatchPopup() {
  const swatchPopup = document.querySelector(".swatch-popup__overlay");
  const swatchPopupOpener = document.querySelector(".swatch-popup__open");
  const swatchPopupCloser = swatchPopup.querySelector(".swatch-popup__close");

  swatchPopup.addEventListener("click", (e) => {
    if (!e.target.closest(".swatch-popup")) {
      swatchPopup.classList.add("hidden");
      document.body.style.overflow = "auto";
    }
  });

  swatchPopupOpener.addEventListener("click", () => {
    swatchPopup.classList.remove("hidden");
    document.body.style.overflow = "hidden";
  });

  swatchPopupCloser.addEventListener("click", () => {
    swatchPopup.classList.add("hidden");
    document.body.style.overflow = "auto";
  });
}

if (document.readyState == "loading")
  document.addEventListener("DOMContentLoaded", handleSwatchPopup);
else handleSwatchPopup();
